<template>
    <div>
        <h1>{{ $t('nav.logout') }}</h1>

        <span :show="error" class="error">{{errorMessage}}</span>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                error: false,
                errorMessage: null
            }
        },
        mounted () {
            this.$api.userLogout();
        }
    }
</script>